/* eslint "react/no-unstable-nested-components": "off" */
import React, { useContext, useMemo, createElement } from 'react';
import parse, { domToReact } from 'html-react-parser';
import { Element } from 'domhandler';
import { HeadingBorder, Section } from '@stereoagency/ui';
import { LinesContext } from '@/components/LinesContext';

type Props = {
  data: {
    content?: string
    darkbackground?: boolean
  }
};

export default function NvisoContainerContent({ data: { content, darkbackground } }: Props) {
  const { enableLines } = useContext(LinesContext);
  const bgColor = darkbackground ? 'offdefault' : 'default';
  const children = useMemo(() => (content ? parse(content, {
    replace: (domNode) => {
      if ('tagName' in domNode && 'attribs' in domNode) {
        const {
          tagName, childNodes,
        } = domNode as Element;
        if (tagName === 'h3') {
          return (
            <HeadingBorder>
              {createElement('h3', {}, domToReact(childNodes))}
            </HeadingBorder>
          );
        }
      }

      return domNode;
    },
  }) : null), [content]);

  if (!children) return null;

  return (
    <Section container lines={enableLines ? 'dark' : false} backgroundColor={bgColor} className="prose prose-img:w-full md:prose-md">
      {children}
    </Section>
  );
}
